export enum TaskCategory {
  PLATFORM = 'platform',
  TWITTER = 'twitter',
  SPECIAL = 'special',
}

export enum TaskType {
  // Platform Tasks - Daily
  DAILY_CHECKIN = 'daily_checkin',
  NEW_YEAR_BURN = 'new_year_burn',
  FIRST_CHEST = 'first_chest',
  POINT_STARTER = 'point_starter',

  // Platform Tasks - Streaks
  STREAK_3 = 'streak_3',
  STREAK_7 = 'streak_7',
  STREAK_15 = 'streak_15',

  // Platform Tasks - Weekly
  WEEKLY_PURGE = 'weekly_purge',
  BOX_COLLECTOR = 'box_collector',
  POINT_ACCUMULATOR = 'point_accumulator',
  TOKEN_VARIETY = 'token_variety',

  // Platform Tasks - Campaign
  TOTAL_BURN_MASTER = 'total_burn_master',
  BOX_LEGEND = 'box_legend',
  POINT_TYCOON = 'point_tycoon',

  // Twitter Tasks - One-time
  TWITTER_FOLLOW = 'twitter_follow',
  TWITTER_LIKE_RT = 'twitter_like_rt',

  // Twitter Tasks - Daily
  TWEET_RESULT = 'tweet_result',
  REPLY_PROMPT = 'reply_prompt',
  RT_USER_CONTENT = 'rt_user_content',
  MORNING_CHECKIN = 'morning_checkin',

  // Twitter Tasks - Weekly
  PROGRESS_THREAD = 'progress_thread',
  MEME_CREATION = 'meme_creation',

  // Twitter Tasks - Campaign
  VIRAL_CHALLENGE = 'viral_challenge',
  THREAD_SERIES = 'thread_series',

  // Special Tasks
  REFERRAL_CHAIN = 'referral_chain',
  COMMUNITY_MILESTONE = 'community_milestone',
  PARTICIPANT_MILESTONE = 'participant_milestone',
}

export interface TaskProgress {
  id: number;
  type: TaskType;
  category: TaskCategory;
  resetPeriod: 'once' | 'daily' | 'weekly' | 'campaign';
  name: string;
  description: string | null;
  points: number;
  maxCompletions: number;
  currentCompletions: number;
  currentProgress: number;
  targetProgress: number;
  isCompleted: boolean;
  canComplete: boolean;
  requiresVerification: boolean;
  verificationType: string | null;
  pendingReview?: boolean;
}

export interface CampaignStatus {
  campaign: {
    year: number;
    phase: 'before' | 'early_access' | 'active' | 'ended';
    earlyAccessStart: string;
    campaignStart: string;
    campaignEnd: string;
    drawDate: string | null;
    prizePool: string;
  } | null;
  user: {
    hasEarlyAccess: boolean;
    totalPoints: number;
    platformPoints: number;
    twitterPoints: number;
    specialPoints: number;
    currentStreak: number;
    rank: number | null;
  } | null;
  caps: {
    total: number;
    platform: number;
    twitter: number;
    special: number;
    twitterDaily: number;
    twitterWeekly: number;
  };
  stats: {
    totalParticipants: number;
    totalPoints: number;
  };
}

export interface TasksResponse {
  tasks: TaskProgress[];
}

export interface CompleteTaskResponse {
  taskType: TaskType;
  pointsAwarded: number;
  capped: boolean;
  newTotalPoints: number;
  completionCount: number;
}

export interface CheckinResponse {
  success: boolean;
  pointsAwarded: number;
  newStreak: number;
  streakBonusAwarded?: number;
}
